import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllVideosInterface {
  status: string;
  search: string;
}

export const useGetAllVideos = () => {
  const mutate = useMutation(({ status, search }: GetAllVideosInterface) => {
    return get(`/external-api/searchVideosByTitleAndStatus/${status}/${search}`);
  });

  return mutate;
};

export default useGetAllVideos;
